module.exports = __webpack_public_path__ + "static/media/2.970fdd0e.jpg";